import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=35fb6b90&scoped=true&"
import script from "./BillsList.vue?vue&type=script&lang=js&"
export * from "./BillsList.vue?vue&type=script&lang=js&"
import style0 from "./BillsList.vue?vue&type=style&index=0&id=35fb6b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb6b90",
  null
  
)

export default component.exports